export default {
  title: {
    suffix: ' (dev)',
  },

  api: {
    baseUri: '//localhost:4000/api',
  },

  socket: {
    uri: '//localhost:4000/',
  },
}
